import React from "react";
import { Card, Pagination, Table } from "flowbite-react";
import EmptyState from "../feedback/EmptyState";
import PageLoader from "../feedback/PageLoader";

export default function DataTable({
  columns,
  rows = [],
  loading = false,
  emptyTitle = "No records found",
  emptyDescription,
  pagination,
  tableClassName = "",
  bodyClassName = "divide-y",
  wrapperClassName = "h-[50vh]",
}) {
  const shouldPaginate =
    pagination && rows.length > 0 && Number(pagination.totalPages || 0) > 1;

  return (
    <>
      <Card className="rounded-lg my-4">
        <div
          className={`overflow-x-auto overflow-y-auto scrollbar-always-visible ${wrapperClassName}`}
        >
          {loading ? (
            <PageLoader label="Loading records..." />
          ) : (
            <Table hoverable className={tableClassName}>
              <Table.Head>
                {columns.map((column) => (
                  <Table.HeadCell key={column.key}>
                    {column.header}
                  </Table.HeadCell>
                ))}
              </Table.Head>

              <Table.Body className={bodyClassName}>
                {rows.length === 0 ? (
                  <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                    <Table.Cell colSpan={columns.length} className="p-0">
                      <EmptyState
                        title={emptyTitle}
                        description={emptyDescription}
                      />
                    </Table.Cell>
                  </Table.Row>
                ) : (
                  rows.map((row, rowIndex) => (
                    <Table.Row
                      key={row.id || row._id || rowIndex}
                      className={
                        row.rowClassName ||
                        "bg-white dark:border-gray-700 dark:bg-gray-800"
                      }
                    >
                      {columns.map((column) => (
                        <Table.Cell
                          key={column.key}
                          className={column.className}
                        >
                          {column.render
                            ? column.render(row, rowIndex)
                            : row[column.key]}
                        </Table.Cell>
                      ))}
                    </Table.Row>
                  ))
                )}
              </Table.Body>
            </Table>
          )}
        </div>
      </Card>

      {shouldPaginate && (
        <div className="flex overflow-x-auto sm:justify-center mb-5">
          <Pagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={pagination.onPageChange}
            showIcons
            previousLabel=""
            nextLabel=""
          />
        </div>
      )}
    </>
  );
}
